import React, {useEffect, useState} from "react";
import {useSearchParams} from "react-router-dom";
import {useGetUserQuery} from "../../store/backend-api/backend.api";
import {UserFormEdit} from "../../components/users/UserFormEdit";

export function EditUserForm() {
    const [searchParams] = useSearchParams()
    const id = Number(searchParams.get("id"))
    const {data, isSuccess} = useGetUserQuery(id)
    const [key, setKey] = useState(0)

    useEffect(() => {
        setKey((prevState) => prevState + 1)
    }, [data])

    if (isSuccess) {
        return (<div key={key}>
            <UserFormEdit data={data}/>
        </div>)
    }
    return (<div>
        Загружаем...
    </div>)
}